// src/client/lib/contrast.ts
//
// #706 (gap-g5): 屋外向けの高コントラスト表示を **利用者が手で** 切り替える (OS の設定に頼らない)。
//   - 端末ごとの設定 (localStorage)。 読めない / 書けない (private mode など) ときは通常表示のまま、 画面は壊さない
//   - 有効 = <html data-contrast="high">。 色の上書きは src/client/index.css の html[data-contrast="high"] だけ
//   - 既定は通常表示 (何も変えない)。 起動時に main.tsx が applyStoredContrast() を呼ぶ (全画面に効く)

export const CONTRAST_STORAGE_KEY = "housing-os:ui:contrast";
export type ContrastMode = "normal" | "high";

export function readContrast(): ContrastMode {
  try {
    return localStorage.getItem(CONTRAST_STORAGE_KEY) === "high" ? "high" : "normal";
  } catch {
    return "normal";
  }
}

export function applyContrast(mode: ContrastMode): void {
  if (typeof document === "undefined") return;
  if (mode === "high") document.documentElement.setAttribute("data-contrast", "high");
  else document.documentElement.removeAttribute("data-contrast");
}

export function saveContrast(mode: ContrastMode): void {
  try {
    if (mode === "high") localStorage.setItem(CONTRAST_STORAGE_KEY, "high");
    else localStorage.removeItem(CONTRAST_STORAGE_KEY);
  } catch {
    // 保存できなくても今の画面には効かせる (次の起動で通常に戻るだけ)
  }
  applyContrast(mode);
}

export function applyStoredContrast(): void {
  applyContrast(readContrast());
}
